import React, { useContext } from 'react';
import { useLoaderData } from 'react-router-dom';
import { CartContext } from '../../layout/Main';
import Cart from '../Cart/Cart';
import Product from '../Product/Product';

const Fashion = () => {
    const fashion = useLoaderData()
    const [cart ,setCart] = useContext(CartContext);
    const handleAddToCart = (product) =>{
        console.log(product.id);
        const exitsProduct = cart.find( item => item.id === product.id );
        console.log(exitsProduct)

        if(exitsProduct){

        }else{
            const newCart = [...cart , product];
            setCart(newCart);
        }

        console.log(cart)
    }
 
    return (
        <section className='fashion mb-10'>
        <div className="container mx-auto">
        <h2 className="text-4xl">
        This is Fashion Page {
            fashion.length
        }
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 my-10">
                    
                    {
                        fashion.map( product => <Product                        
                        key={product.id}
                        product = {product}
                        handleAddToCart = {handleAddToCart}
                        >

                        </Product>)
                    }
				</div>
               

        </div>
    </section>
    );
};

export default Fashion;